import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'ravis-academy';
  isHeaderVisible: boolean = false;
  isFooterVisible: boolean = false;
  userName: string = '';

  constructor(private router: Router, private commonService: CommonService) {
    this.commonService.getFullName().subscribe((name) => {
      this.userName = name;
    });
  }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (
          val.url === '/' ||
          val.url.startsWith('/login') ||
          val.url.startsWith('/register')
        ) {
          console.log(val);
          this.isFooterVisible = false;
          this.isHeaderVisible = false;
        } else if (val.url === '/dashboard') {
          this.isFooterVisible = true;
          this.isHeaderVisible = true;
        }
      }
    });
  }
}
